import { getErrorPayload } from '@application/common/helpers/api-helper';
import { translate } from '@application/common/helpers/translate';
import FileApi from '@infrastructure/file-api';
import FreelancerApi from '@infrastructure/freelancer-api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { addSuccessNotification } from '../common/notificationSlice';
export const updateFreelancerAsync = createAsyncThunk('freelancer/update', async (freelancer, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await FreelancerApi.updateFreelancerAccount(freelancer);
        dispatch(addSuccessNotification(translate('account.profileUpdatedSuccessfully')));
        dispatch(getFreelancerAsync());
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const updateFreelancerUserAsync = createAsyncThunk('freelancer/updateUser', async (freelancer, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await FreelancerApi.updateFreelancerUserAccount(freelancer);
        dispatch(addSuccessNotification(translate('account.profileUpdatedSuccessfully')));
        if (freelancer.id)
            dispatch(getFreelancerByIdAsync(freelancer.id));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getFreelancerAsync = createAsyncThunk('freelancer/getAccount', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await FreelancerApi.getFreelancerAccount();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFreelancerByIdAsync = createAsyncThunk('freelancer/getAccount', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await FreelancerApi.getFreelancerAccountById(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getProfileAsync = createAsyncThunk('freelancer/getProfile', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await FreelancerApi.getFreelancerProfile();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const uploadProfilePictureAsync = createAsyncThunk('freelancer/uploadProfilePicture', async (file, { rejectWithValue, dispatch }) => {
    try {
        const response = await FreelancerApi.uploadProfilePicture(file);
        dispatch(addSuccessNotification(translate('account.profileUpdatedSuccessfully')));
        dispatch(getFreelancerAsync());
        return response.data;
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const downloadCOCDocumentAsync = createAsyncThunk('freelancer/downloadCOC', async (file, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await FileApi.downloadFile(file.folderName, file.fileName);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const downloadFreelancerTermsAndConditionsAsync = createAsyncThunk('freelancer/downloadFreelancerTermsAndConditions', async (file, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await FileApi.downloadFile(file.folderName, file.fileName);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const downloadPlacementDocumentAsync = createAsyncThunk('Placement/Placementdownload', async (file, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await FileApi.downloadFile(file.folderName, file.fileName);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
